import React, { useState } from "react";
import CcmodeUserTable from "./CcmodeUserTable";
import { FaLink, FaPlus } from "react-icons/fa";
import CcmodeInviteUserForm from "./CcmodeInviteUserForm";
import { Button, makeStyles,Typography, Tabs, Tab,} from "@material-ui/core";
import CcmodeUpdatePassword from "./CcmodeUpdatePassword";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CCMODE_BASE_URL, NODE_API_URL, BASE_URL } from "./../../../../env_config";
import { BsArrowLeftShort } from "react-icons/bs";
import CcmodeUserInvitationTable from "./CcmodeUserInvitationTable";
import { IoIosOpen } from "react-icons/io";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import axios from "axios";

const CUSTOMER_DATA = localStorage.getItem("userData");

function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const INVITE_USER_INTIAL_OBJ = {
    customerId: CUSTOMER_DATA ? JSON.parse(CUSTOMER_DATA)?.CustomerId : "",
    email: "",
    permissions: [],
    displayName: "",
};

const useStyles = makeStyles((theme) => ({
    inviteBtn: {
        minWidth: "100px",
        minHeight: "33px",
        fontSize: "12px",
        background:
            "linear-gradient(45deg, hsla(223, 100%, 37%, 1) 0%, hsla(197, 100%, 50%, 1) 100%)",
        color: "#fff !important",
        fontWeight: 500,
        borderRadius: "5px",
        border: "none",
        fontFamily: 'Poppins, Helvetica, "sans-serif"',
    },
    subText: {
        fontSize: "11px",
        fontWeight: "300",
        textTransform: "capitalize",
    },
    saveBtn: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    copyInput: {
        height: "32px",
        borderRadius: "5px 0 0 5px",
        border: "1px solid #004CC8",
        background: "#fff",
    },
    copyBtn: {
        height: "32px",
        minWidth: "34px",
        width: "34px",
        boxShadow: "none",
        borderRadius: "0px",
        "& .MuiButton-label": {
            width: "unset",
        },
        borderLeft: "1px solid #fff",
        borderRight: "1px solid #fff",
    },
    newTabBtn: {
        height: "32px",
        minWidth: "34px",
        width: "34px",
        boxShadow: "none",
        borderRadius: "0 5px 5px 0",
        "& .MuiButton-label": {
            width: "unset",
        },
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
    copyContainer: {
        display: "flex",
        justifyContent: "end",
        padding: `${0.25 * 5  }rem 0`,
        paddingLeft: `12.5px`,
        paddingRight: `12.5px`,
        width: "100%",
    },
    copyInner: {
        display: "flex",
        [theme.breakpoints.down("xs")]: {
            flexGrow: 1,
        },
    },
}));

export default function CcmodeInviteUser({ language, ccmodesetting }) {        
    const { features } = useSelector((state) => state.plan);
    const CCModeBaseUrl = ccmodesetting.client_domain || CCMODE_BASE_URL;

    const classes = useStyles();
    const [value, setValue] = useState(0);

    const [inviteUserForm, setInviteUserForm] = useState({
        isOpen: false,
        userObj: INVITE_USER_INTIAL_OBJ,
        isUpdating: false,
    });

    const [updatePassword, setUpdatePassword] = useState({
        isOpen: false,
        id: "",
        customer_id: "",
    });

    const inviteUser = () => {
        if (features["create_multi_user"]?.allowed === 0) {
            toast.dismiss();
            return toast.error(<div><b>Feature unavailable.</b> <br></br>Please contact your account manager to upgrade your plan.</div>);
        }
        setInviteUserForm((prev) => ({
            userObj: INVITE_USER_INTIAL_OBJ,
            isOpen: true,
            isUpdating: false,
        }));
    };

    const renderTitle = () => {
        if (inviteUserForm.isOpen && !inviteUserForm.isUpdating) {
            return (
                <>
                    <span>INVITE USER</span>
                    <span className="small text-capitalize">
                        fill form to send invitation
                    </span>
                </>
            );
        } else if (inviteUserForm.isOpen && inviteUserForm.isUpdating) {
            return (
                <>
                    <span>UPDATE USER</span>
                    <span className="small text-capitalize">
                        fill form to update user
                    </span>
                </>
            );
        } else if (updatePassword.isOpen) {
            return (
                <>
                    <span>UPDATE PASSWORD</span>
                    <span className="small text-capitalize">
                        fill form to update password
                    </span>
                </>
            );
        } else {
            return (
                <>
                    <span>CCMODE MANAGE USER SETTING</span>
                    <span className="small text-capitalize">
                        client centric manage user setting
                    </span>
                </>
            );
        }
    };

    function handleTabChange(event, newValue) {
        window.glob = newValue
        setValue(newValue);
    }

    const renderMainContent = () => {
        if (inviteUserForm.isOpen || inviteUserForm.isUpdating) {
            return (
                <CcmodeInviteUserForm
                    language={language}
                    inviteUserObj={inviteUserForm}
                    setInviteUserForm={setInviteUserForm}
                />
            );
        } else if (updatePassword.isOpen) {
            return (
                <CcmodeUpdatePassword
                    language={language}
                    updatePassword={updatePassword}
                    setUpdatePassword={setUpdatePassword}
                />
            );
        } else {
            return (
                <>
                
                {value === 0 && ( 
                    <TabContainer>
                        {/* <div className="setting-title ccmode-setting-sticky-header pt-2 pb-10 border-bottom">
                            Users list
                        </div> */}
                        <CcmodeUserTable
                            setInviteUserForm={setInviteUserForm}
                            setUpdatePassword={setUpdatePassword}
                        />
                    </TabContainer>
                )}
                {value === 1 && ( 
                   <TabContainer>
                        {features["create_multi_user"]?.allowed === 0 ? (
                            ""
                        ) : (
                            <>
                                {/* <div className="setting-title ccmode-setting-sticky-header pt-2 pb-10 border-bottom">
                                    invitations list
                                </div> */}
                                <CcmodeUserInvitationTable />
                            </>
                        )}
                   </TabContainer>
                )}
                </>
            );
        }
    };

    const copyUrl = () => {
        navigator.clipboard.writeText(CCModeBaseUrl);
        toast.dismiss();
        toast.success("Copied to Clipboard");
    };

    async function handleCCModeBtn() {
        try {
        const res = await axios({
            method: "GET",
            url: `${NODE_API_URL}/INTL/generate-auto-login-token`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        });

        if (res && res.data && res.data.success) {
            const token = res.data.token;
            console.log(ccmodesetting);
            const clientURL = `${ccmodesetting.client_domain || CCMODE_BASE_URL}?autoLoginToken=${encodeURIComponent(
                token
            )}`;
            window.open(clientURL, "_blank");
        }
        } catch (error) {
            if (error?.response?.data?.message === "UnAuthorized!") {
                var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                    if (cookies[i] && !cookies[i].includes("view")) {
                        var equals = cookies[i].indexOf("=");
                        var name =
                            equals > -1
                                ? cookies[i].substr(0, equals)
                                : cookies[i];
                        document.cookie =
                            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                }
                window.location.replace(`${BASE_URL}/logout`);
            }
        }
    }

    return (
        <div className="row allign-items-center">
            <div className="col-12 ccmode-setting-sticky-header">
                <div className="setting-title pb-3 pt-2">
                    <span
                        className="cursor-pointer text-hover-primary small setting-title"
                        onClick={() => window.history.go(-1)}
                    >
                        <BsArrowLeftShort /> Back to dashboard
                    </span>
                </div>
                <div
                    className={`col-12 setting-title pb-5 px-0 border-bottom ${
                        classes.cardHeader
                    } ${
                        !inviteUserForm.isOpen && !updatePassword.isOpen
                            ? ""
                            : ""
                    }`}
                >
                    <div className="d-flex flex-column">{renderTitle()}</div>
                    <div>
                        {!inviteUserForm.isOpen && !updatePassword.isOpen ? (
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.saveBtn}
                                onClick={inviteUser}
                            >
                                <FaPlus className="mr-1" />
                                INVITE USER
                            </Button>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
            {!inviteUserForm.isOpen && !updatePassword.isOpen ? (
                <div className="col-12">
                    <div className={`border-bottom d-flex justify-content-${features["create_multi_user"]?.allowed === 0 ? "end" : "between"} align-items-center`}>
                        <div className="">
                            {features["create_multi_user"]?.allowed === 0 ? null : (
                                <Tabs variant="scrollable" value={value} onChange={handleTabChange}>
                                    <Tab label="Users list" />
                                    <Tab label="Invitations list" />
                                </Tabs>
                            )}
                       </div>
                        <div className={`${classes.copyContainer}`}>
                            <div className={`${classes.copyInner}`}>
                                <input
                                    type="text"
                                    value={CCModeBaseUrl}
                                    disabled
                                    className={`form-control disabled m-0 ${classes.copyInput}`}
                                />
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.copyBtn}
                                    onClick={() => copyUrl()}
                                >
                                    <FaLink fontSize={16} />
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.newTabBtn}
                                    onClick={() => handleCCModeBtn()}
                                >
                                    <IoIosOpen fontSize={16} />
                                </Button>
                            </div>
                        </div>
                       
                    </div>
                </div>
            ) : (
                ""
            )}
            <div className="col-12 pt-4">{renderMainContent()}</div>
        </div>
    );
}
